import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ArrowRight2px, Sizes } from "@/components/icon/IconList";
import { PASSES_LANDING } from "@/settings/constant";
import { Button } from "@bookips/solvook-ui-library";
import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import { useRouter } from "next/router";
import { Subjects } from "src/api/product";
import { TabMessageBox } from "./PurchaseLayouts";
import PurchaseOption from "./PurchaseOption";
const NoPassUsageTab = (param)=>{
    let { product , hasNoPasses  } = param;
    const theme = useTheme();
    const router = useRouter();
    const handleClick = ()=>{
        var _product_source;
        var _product_source_subject;
        const subject = (_product_source_subject = (_product_source = product.source) === null || _product_source === void 0 ? void 0 : _product_source.subject) !== null && _product_source_subject !== void 0 ? _product_source_subject : Subjects.EN;
        router.push("".concat(PASSES_LANDING, "?subject=").concat(subject));
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(TabMessageBox, {
                sx: {
                    my: 2.5
                },
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle1",
                        sx: {
                            color: "text.secondary"
                        },
                        children: hasNoPasses ? "등록된 이용권이 없어요." : /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                "해당 자료에 사용 가능한",
                                /*#__PURE__*/ _jsx("br", {}),
                                "이용권이 없어요."
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs(ButtonBase, {
                        disableRipple: true,
                        sx: {
                            color: "secondary.main",
                            pt: 1.5,
                            width: "100%"
                        },
                        onClick: handleClick,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle2",
                                sx: {
                                    color: "primary.main"
                                },
                                children: "이용권 구매하기"
                            }),
                            /*#__PURE__*/ _jsx(ArrowRight2px, {
                                size: Sizes.small,
                                color: theme.palette.primary.main
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                marginBottom: 2.5,
                children: /*#__PURE__*/ _jsx(PurchaseOption, {})
            }),
            /*#__PURE__*/ _jsx(Button, {
                size: "large",
                variant: "contained",
                fullWidth: true,
                disabled: true,
                children: "이용권 사용하기"
            })
        ]
    });
};
export default NoPassUsageTab;
